import Immutable from 'immutable';
/* @ts-expect-error module is untyped */

import { cleanObject } from 'ecosystem-marketplace-core/utils/formatters';
/* @ts-expect-error module is untyped */

import ReviewSummary from 'ecosystem-marketplace-core/records/ReviewSummary';
const defaults = {
  offeringId: 0,
  slug: '',
  name: '',
  companyName: '',
  featureHeadlines: Immutable.List(),
  installsCount: 0,
  priceCents: 0,
  thumbnailUrl: '',
  reviewSummary: null
};

class ThemeCardResult extends Immutable.Record(defaults) {
  constructor(json = {}) {
    const jsonCopy = Object.assign({}, json);

    if (json.featureHeadlines) {
      jsonCopy.featureHeadlines = Immutable.List(json.featureHeadlines);
    }

    if (json.reviewSummary) {
      jsonCopy.reviewSummary = new ReviewSummary(json.reviewSummary);
    }

    super(cleanObject(jsonCopy));
  }

}

export default ThemeCardResult;